import { ExperienceLink } from "src/app/models/experience-link";
import { Record } from "src/app/models/record";

export class OpenDialog {
  static readonly type = '[Bookclub links] - Open dialog';

  constructor(public record: Record, public links: ExperienceLink[], public resourceId?: string) { }
}

export class CloseDialog {
  static readonly type = '[Bookclub links] - Close dialog';
}

export class SendBookClubHistory {
  static readonly type = '[Bookclub links] - Send book club history';

  constructor(
    public recordId: string,
    public link: ExperienceLink,
    public dontShow: boolean) { }
}
